import React, { useEffect } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
// import axios from 'axios';
// import { Typography } from '@material-ui/core';

// import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Notification from './Notification';
import api from '../../../../services/api'

import { logout } from "../../../../auth";
import socketIOClient from "socket.io-client";
const ENDPOINT = "http://186.205.67.216:400";


const useStyles = makeStyles(theme => ({
  root: {
    // boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  titlepage: {
    color: 'white',
    fontSize: 28,
    fontFamily: 'Nunito'
  }
}));

const Topbar = props => {
  let history = useHistory();
  const { className, onSidebarOpen, ...rest } = props;
  const classes = useStyles();
  const [notifications, setNotifications] = React.useState([]);

  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [response, setResponse] = React.useState("");
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      // const result = await api.get('notificacoes', {});
      // setNotifications(result.data);
    };
    fetchData();
  }, []);


  // useEffect(() => {
  //   const socket = socketIOClient(ENDPOINT);
  //   socket.emit('notifications', { NOTIFICACAO: localStorage.getItem("@CPF") });

  // }, []);

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Toolbar>
        <RouterLink to="/">

          <div className={classes.titlepage}>{"MexBrasil"}</div>
          {/* <img
            alt="Logo"
            src={require('../../../../assets/img/login.png')}
            style={{ width: '150px' }}
          /> */}
        </RouterLink>
        <div className={classes.flexGrow} />
        {auth && (
          <Hidden mdDown>
            <React.Fragment>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <Badge badgeContent={notifications.length} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
              >
                <Notification dataSource={notifications} />
              </Menu>
            </React.Fragment>
            <IconButton
              className={classes.signOutButton}
              color="inherit"
              // onClick={() => { localStorage.removeItem('@CPF') }}

              onClick={() => {
                console.log(history)
                history.push("/login");
                logout();
              }}
            >
              <InputIcon />
            </IconButton>
          </Hidden>)}
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
